import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Search, ArrowRight } from "lucide-react";
import OpsTopBar from "../../components/ops/OpsTopBar";
import { BranchAvatar, OperatorAvatar } from "../../components/ops/BranchAvatar";
import AllowanceBar from "../../components/ops/AllowanceBar";
import useApi from "../../hooks/useApi";

export default function OpsBranches() {
  const [group, setGroup] = useState("");
  const [search, setSearch] = useState("");
  const params = new URLSearchParams();
  if (group) params.set("group_id", group);
  if (search) params.set("search", search);
  const path = `/ops/branches?${params.toString()}`;
  const { data } = useApi(path, [path]);
  const branches = data?.branches || [];
  const groups = data?.groups || [];
  const { data: ops } = useApi("/ops/operators");
  const opMap = Object.fromEntries((ops?.operators || []).map((o) => [o.id, o]));

  return (
    <>
      <OpsTopBar title="Branches" subtitle={`${branches.length} managed branches`} />
      <div className="p-6 sm:p-8 max-w-[1400px] space-y-5">
        <div className="relative max-w-xl">
          <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-ink-3" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} data-testid="branches-search"
            placeholder="Search branch or agency…" className="w-full rounded-full border bg-white pl-10 pr-4 py-2.5 text-sm text-ink focus-ring" style={{ borderColor: "#E7E8E4" }} />
        </div>
        <div className="flex flex-wrap gap-2" data-testid="branches-groups">
          <button onClick={() => setGroup("")} className="rounded-full px-3.5 py-1.5 text-sm font-medium border" style={group === "" ? { background: "var(--grad-ink)", color: "#fff", borderColor: "transparent" } : { color: "#6B6E62", borderColor: "#E7E8E4", background: "#fff" }}>All agencies</button>
          {groups.map((g) => (
            <button key={g.id} onClick={() => setGroup(g.id)} data-testid={`group-${g.id}`} className="rounded-full px-3.5 py-1.5 text-sm font-medium border" style={group === g.id ? { background: g.color, color: "#fff", borderColor: "transparent" } : { color: "#6B6E62", borderColor: "#E7E8E4", background: "#fff" }}>{g.name}</button>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {branches.map((b) => {
            const op = opMap[b.operator_id];
            return (
              <Link key={b.id} to={`/ops/branches/${b.id}`} className="card card-hover p-5" data-testid={`branch-card-${b.id}`}>
                <div className="flex items-center gap-3">
                  <BranchAvatar initials={b.initials} color={b.color} size={44} />
                  <div className="min-w-0">
                    <div className="font-bold tracking-tight text-ink truncate">{b.name}</div>
                    <div className="text-xs text-ink-3 truncate">{b.group_name} · {b.handle}</div>
                  </div>
                </div>
                <div className="mt-4"><AllowanceBar allowance={b.allowance} reset={b.allowance_reset} /></div>
                <div className="flex items-center justify-between mt-4 pt-3 border-t" style={{ borderColor: "#EDEEE9" }}>
                  <span className="flex items-center gap-2 text-xs text-ink-2">{op && <OperatorAvatar initials={op.initials} color={op.color} size={22} />}{op?.name || "Unassigned"}</span>
                  <span className="text-xs font-semibold inline-flex items-center gap-1" style={{ color: "#5F8213" }}>Open <ArrowRight size={12} strokeWidth={2} /></span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
}
